export const ITEMS_PER_PAGE = 10;

export const INITIAL_WAREHOUSE_STATE = {
  uuid: null,
  code: '',
  name: '',
  uuid_branch: '',
  address: '',
  is_active: true,
};

export const VALIDATION_RULES = {
  CODE_MAX_LENGTH: 50,
  NAME_MAX_LENGTH: 150,
  ADDRESS_MAX_LENGTH: 255,
};

export const MESSAGES = {
  ERROR: {
    REQUIRED_FIELD: 'Este campo es obligatorio',
    CODE_MAX_LENGTH: `Máximo ${VALIDATION_RULES.CODE_MAX_LENGTH} caracteres`,
    NAME_MAX_LENGTH: `Máximo ${VALIDATION_RULES.NAME_MAX_LENGTH} caracteres`,
    ADDRESS_MAX_LENGTH: `Máximo ${VALIDATION_RULES.ADDRESS_MAX_LENGTH} caracteres`,
  },
};
